import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { OrganizationType } from '@/bundle/_Opco/types/types';
import { SubscriptionPlanType } from '@/const/shared';

export type CreateOrganizationWithExistingUserPayloadType = {
  organization: {
    name: string;
    subscription_plan_type: SubscriptionPlanType;
    is_kyc_allowed: boolean;
  };
  user_id: string;
};

export const createOrganizationWithExistingUserApi = (
  data: CreateOrganizationWithExistingUserPayloadType,
  options?: RequestOptions
): Promise<ApiResponseType<OrganizationType>> => {
  const uri = '/opco/users/organization:add/';

  return authApiService.POST(uri, data, null, options);
};
